import { render, staticRenderFns } from "./EscolhaAmbientes.vue?vue&type=template&id=44a68d1e&scoped=true&"
import script from "./EscolhaAmbientes.vue?vue&type=script&lang=js&"
export * from "./EscolhaAmbientes.vue?vue&type=script&lang=js&"
import style0 from "./EscolhaAmbientes.vue?vue&type=style&index=0&id=44a68d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a68d1e",
  null
  
)

export default component.exports